/* eslint-disable complexity */
export const MODE = {
  name: "linkfluence-query",
  fn: () => {
    const escapedChar = "\\\\.";
    const startChar =
      "(" +
      escapedChar +
      '|[^\\ \\t\\n\\r\u3000\\+\\-\\!\\(\\)\\:\\^\\[\\]"\\{\\}\\~\\*\\?\\\\\\/\\<])';
    const termChar = "(" + startChar + "|" + escapedChar + "|\\+|-)";
    const term = startChar + termChar + "*";
    const star = "\\*";
    const prefixTerm = "(\\*|" + startChar + termChar + "*\\*)";
    const ws = "[\\ \\t\\n\\r\u3000]";
    const bareoper = "(\\+|\\-|\\!)(?=" + ws + "|$)";
    const wildTerm =
      "((\\*|\\?)|" + startChar + ")(" + termChar + "|(\\*|\\?))*";
    const number = "\\d+(\\.\\d+)?";

    const termRE = new RegExp(
      "^(" +
        term +
        "|" +
        star +
        "|" +
        prefixTerm +
        "|" +
        wildTerm +
        "|" +
        number +
        "|" +
        bareoper +
        ")"
    );
    const fieldRE = new RegExp("^" + term + ws + "*\\:");
    const operator = new RegExp(
      "^(AND|OR|&&|\\|\\||NOT|NEAR/\\d+|<<\\d+)(?=" + ws + "|$)"
    );
    const operator2 = new RegExp("^[\\+\\-!](?=" + startChar + ")"); // prefix operators
    const regexpRE = new RegExp("^\\/([^\\/]|\\\\/)*\\/");
    const fuzzySlopRE = new RegExp(
      "^\\~((\\d+(\\.\\d+)?" + termChar + "*)|" + termChar + "*)"
    );
    const quorumRE = new RegExp("^\\/\\d+");
    const boostRE = new RegExp("^\\^" + number);

    const hasTypeContext = (state, type) => {
      if (state.context) {
        return state.context.type === type;
      }

      return false;
    };

    let tokenBase: any = undefined;

    const tokenPhrase = (stream, state) => {
      stream.next();
      let next;
      let escaped = false;
      let end = false;
      while ((next = stream.next())) {
        if (next === '"' && !escaped) {
          end = true;
          break;
        }

        escaped = !escaped && next === "\\";
      }

      if (end || !escaped) {
        state.tokenize = tokenBase;
      }

      return "phrase";
    };

    tokenBase = (stream, state) => {
      const ch = stream.peek();
      if (ch === '"') {
        state.tokenize = tokenPhrase;
        return state.tokenize(stream, state);
      } else if (ch === "(" || ch === ")") {
        stream.next();
        return "paren";
      } else if (stream.match(operator) || stream.match(operator2)) {
        return "operator";
      } else if (stream.match(fieldRE)) {
        if (hasTypeContext(state, "field")) {
          return "error";
        } else {
          return "field";
        }
      } else if (stream.match(termRE)) {
        return "term";
      } else if (stream.match(quorumRE)) {
        if (hasTypeContext(state, "phrase")) {
          return "boost";
        } else {
          return "error";
        }
      } else if (stream.match(boostRE)) {
        if (
          (hasTypeContext(state, "paren") && state.context.tok === ")") ||
          hasTypeContext(state, "term") ||
          hasTypeContext(state, "phrase") ||
          (hasTypeContext(state, "boost") && state.context.tok[0] === "~")
        ) {
          return "boost";
        } else {
          return "error";
        }
      } else if (stream.match(fuzzySlopRE)) {
        if (hasTypeContext(state, "phrase") || hasTypeContext(state, "term")) {
          return "boost";
        } else {
          return "error";
        }
      } else if (stream.match(regexpRE)) {
        return "regex";
      } else {
        stream.next();
        return "error";
      }
    };

    const pushContext = (state, type, tok) => {
      state.context = {
        prev: state.context,
        type,
        tok,
      };
    };

    return {
      startState() {
        return {
          tokenize: tokenBase,
          context: null,
        };
      },
      token(stream, state) {
        if (stream.eatSpace()) {
          return null;
        }

        const style = state.tokenize(stream, state);
        const tok = stream.current();
        pushContext(state, style, tok);

        return style;
      },
    };
  },
};
